import script from "./AlarmDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AlarmDashboard.vue?vue&type=style&index=0&id=bab24666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab24666"]])

export default __exports__